export const getTotalHours = (resume) => {
    const hours = Object.keys(resume).reduce((prevVal, index) => prevVal + resume[index].option.time, 300);
    return hours;
}

const hourlyRate = 150;
export const getTotalPrice = (totalHours) => {
    return totalHours * hourlyRate;
}